<template>
  <!-- 增员活动配置弹框 -->
  <div>
    <Form ref="form" :model="formData" :label-width="100" class="page-form">
      <FormItem prop="type" label="活动类型" :rules="$units.formRule.required('请选择')" class="half">
        <RadioGroup v-model="formData.type" @on-change="changeType">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">增员活动（直接推荐人）</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">出单活动（业务员）</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'">签约活动</Radio>
          <Radio label="4" :disabled="formData.status == '1' || formData.status == '-1'" v-if="$units.isOkBao()">报名活动</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem prop="mode" label="活动方式" :rules="$units.formRule.required('请选择活动方式')" class="half">
        <template #label>
          <span>
            活动方式
            <Tooltip transfer max-width="1000">
              <Icon type="md-help-circle" style="color: #a8adb7" size="16" />
              <template #content>
                <p>无门槛：没有条件，只要符合活动类型即可获奖</p>
                <p>梯度：活动有指标，需设置区间，达到对应条件才能获奖</p>
              </template>
            </Tooltip>
          </span>
        </template>
        <RadioGroup v-model="formData.mode" @on-change="changeMode">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">无门槛</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">梯度</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        prop="rewardRate"
        label="活动奖励(%)"
        :rules="$units.formRule.required('请输入活动奖励')"
        v-if="formData.mode == 1"
        class="half"
        :label-width="100"
      >
        <div style="display: flex; align-items: center">
          <Input
            v-model="formData.rewardRate"
            style="width: 300px"
            type="number"
            placeholder="请输入奖励百分比"
            :disabled="formData.status == '1' || formData.status == '-1'"
          />
        </div>
      </FormItem>
      <FormItem prop="conditionalIndicator" label="条件指标" :rules="$units.formRule.required('请选择')" v-if="formData.mode == 2" class="half">
        <RadioGroup v-model="formData.conditionalIndicator" @on-change="changeConditionalIndicator">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">增员人数</Radio>
          <Radio label="6" :disabled="formData.status == '1' || formData.status == '-1'">保单标保</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'">累计保单标保</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        prop="joinType"
        label="参与方式"
        :rules="$units.formRule.required('请选择')"
        :label-width="100"
        v-if="[3, 6].includes(formData.conditionalIndicator*1)"
        class="half"
      >
        <template #label>
          <span>
            参与方式
            <Tooltip transfer max-width="1000">
              <Icon type="md-help-circle" style="color: #a8adb7" size="16" />
              <template #content>
                <p>参与方式为全部参加时，活动期间内符合条件下业务员所有保单都参与活动，参与方式为首单时，活动期间内符合条件下业务员的首单参与活动。</p>
                <p>首单指的是活动期间内第一次投保时出的保单，如若活动期间内退保将自动替换成第二单，以此类推</p>
              </template>
            </Tooltip>
          </span>
        </template>
        <RadioGroup v-model="formData.joinType" @on-change="$emit('typeChange', formData)">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">全部参与</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">仅首单参与</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        key="productType"
        prop="productType"
        label="产品类型"
        :rules="$units.formRule.required('请选择')"
        class="half"
        :label-width="formData.conditionalIndicator == 1 ? 77 : 100"
        v-if="[3, 6].includes(formData.conditionalIndicator*1)"
      >
        <RadioGroup v-model="formData.productType" @on-change="$emit('typeChange', formData), $bus.$emit('resetList', formData)">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1' || id">个险</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1' || id">团险</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem
        prop="recommendTypes"
        label="增员类型"
        :rules="$units.formRule.arrRequired('请选择增员类型', (trigger = 'change'))"
        :disabled="formData.status == '1' || formData.status == '-1'"
        v-if="formData.mode == 2"
        class="half"
        :label-width="78"
      >
        <CheckboxGroup v-model="formData.recommendTypes" key="recommendTypes">
          <Checkbox
            size="small"
            label="1"
            :disabled="[3, 6].includes(formData.conditionalIndicator*1) || formData.status == '1' || formData.status == '-1'"
            v-if="$units.isOkBao() || $units.isOkTX()"
            >注册业务员</Checkbox
          >
          <Checkbox size="small" label="2" :disabled="formData.status == '1' || formData.status == '-1'">入职业务员</Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem
        prop="rewardType"
        label="奖励类型"
        :rules="$units.formRule.required('请选择')"
        class="half"
        v-if="formData.mode == 2 && [3, 6].includes(formData.conditionalIndicator*1)"
        :label-width="100"
      >
        <RadioGroup v-model="formData.rewardType" key="rewardType">
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">加费</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'" v-if="formData.mode == 2">现金</Radio>
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'" v-if="formData.mode == 2">实物</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        prop="rewardType"
        label="奖励类型"
        :rules="$units.formRule.arrRequired('请选择奖励类型', (trigger = 'change'))"
        v-if="formData.mode == 2 && formData.conditionalIndicator == 1"
        class="half"
      >
        <CheckboxGroup v-model="formData.rewardType" @on-change='changeRewardType'>
          <Checkbox value="2" label="2" :disabled="formData.status == '1' || formData.status == '-1'">实物</Checkbox>
          <Checkbox value="3" label="3" :disabled="formData.status == '1' || formData.status == '-1'">现金</Checkbox>
        </CheckboxGroup>
      </FormItem>

      <FormItem
        prop="endorsementIsJoin"
        :label-width="105"
        label="批单是否参加"
        :rules="$units.formRule.required('请选择')"
        v-if="formData.productType == 2"
        class="half"
      >
        <RadioGroup v-model="formData.endorsementIsJoin">
          <Radio label="0" :disabled="formData.status == '1' || formData.status == '-1'">否</Radio>
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">是</Radio>
        </RadioGroup>
      </FormItem>

      <FormItem
        prop="calFactor"
        label="计算因子"
        :rules="$units.formRule.required('请选择计算因子')"
        :label-width="80"
        v-if="formData.mode == 1 || (formData.mode == 2 && [3, 6].includes(formData.conditionalIndicator*1) && formData.rewardType == 1)"
        class="half"
      >
        <RadioGroup v-model="formData.calFactor">
          <Radio label="2" :disabled="formData.status == '1' || formData.status == '-1'">被推荐人规保</Radio>
          <Radio label="1" :disabled="formData.status == '1' || formData.status == '-1'">被推荐人标保</Radio>
          <Radio label="3" :disabled="formData.status == '1' || formData.status == '-1'">被推荐人费用</Radio>
        </RadioGroup>
      </FormItem>
      <!-- 无门槛且增员显示 -->
      <FormItem
        prop="joinPolicyTypeList"
        label="参与保单类型"
        :rules="$units.formRule.arrRequired('请选择参与保单类型')"
        v-if="formData.mode == 1 && formData.conditionalIndicator == 1"
        class="half"
      >
        <CheckboxGroup v-model="formData.joinPolicyTypeList">
          <Checkbox size="small" label="1" :disabled="formData.status == '1' || formData.status == '-1'">个险保单</Checkbox>
          <Checkbox size="small" label="2" :disabled="formData.status == '1' || formData.status == '-1'">团财保单</Checkbox>
          <Checkbox size="small" label="3" :disabled="formData.status == '1' || formData.status == '-1'">团财批增单</Checkbox>
          <Checkbox size="small" label="4" :disabled="formData.status == '1' || formData.status == '-1'">团财批减单</Checkbox>
        </CheckboxGroup>
      </FormItem>
    </Form>

    <div class="tip" v-if="formData.mode == 2">
      <p class="title">配置说明：</p>
      <p>1、最大值和最小值都是包含当前数字，最大值可等于最小值；2、最后一条数据，条件指标最大值可以不填，最后结果为 最小值及以上</p>
    </div>
    <div class="table-box" v-if="formData.mode == 2">
      <Table :columns="columns" :data="tableData">
        <template slot-scope="{ row, index }" slot="action" v-if="formData.status != '1' && formData.status != '-1'">
          <div class="detail">
            <div v-if="!row.isEdit" @click="row.isEdit = true">编辑</div>
            <div @click="delTable(index)">删除</div>
          </div>
        </template>
        <template slot-scope="{ row, column, index }" slot="input">
          <div v-if="[3, 6].includes(formData.conditionalIndicator*1)">
            <Input
              v-model="gradientConfigs[index][column.key]"
              :type="formData.rewardType != 2 && column.title == '奖励' ? 'number' : 'text'"
              placeholder="请输入"
              v-if="row.isEdit"
            />
            <div v-else>
              <span>{{ gradientConfigs[index][column.key] }}</span>
            </div>
          </div>

          <div v-else>
            <Input
              v-model="gradientConfigs[index][column.key]"
              :type="gradientConfigs[index].rewardSelect == 'cashReward' ? 'number' : 'text'"
              placeholder="请输入"
              v-if="row.isEdit"
            />
            <div v-else>
              <span>{{ gradientConfigs[index][column.key] }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row, index }" slot="select">
          <Select v-model="gradientConfigs[index].recommendType" transfer placeholder="请选择增员类型" clearable :disabled="!row.isEdit">
            <Option :value="1" :disabled="!formData.recommendTypes.includes('1')">注册</Option>
            <Option :value="2" :disabled="!formData.recommendTypes.includes('2')">正式</Option>
          </Select>
        </template>
        <template slot-scope="{ row, index }" slot="rewardSelect">
          <Select v-model="gradientConfigs[index].rewardSelect" transfer placeholder="请选择奖励类型" clearable :disabled="!row.isEdit" @on-change='changeRewardSelect($event, gradientConfigs[index])'>
            <Option value="kindReward" :disabled="!formData.rewardType.includes('2')">实物</Option>
            <Option value="cashReward" :disabled="!formData.rewardType.includes('3')">现金</Option>
          </Select>
        </template>
      </Table>

      <div class="btn-item" style="margin-top: 10px">
        <Button
          v-if="formData.status != '-1'"
          type="warning"
          @click="addTable"
          :disabled="!formData.recommendTypes.length || formData.status == '1' || (formData.status == '-1' && !formData.recommendTypes.includes('2'))"
          >新增</Button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { pageTool } from '@/api/mixins';
import _ from 'lodash';
export default {
  components: {},
  props: ['tableList', 'activityType', 'id', 'compontntType'],
  mixins: [pageTool],
  data() {
    return {
      formData: {
        type: '1',
        mode: '1',
        calFactor: '2',
        rewardType1: '1',
        rewardType: [],
        joinPolicyTypeList: [],
        conditionalIndicator: '1',
        productType: '1',
        recommendTypes: ['2'],
        endorsementIsJoin: ''
      },
      tableData: [],
      gradientConfigs: [],
      isSupportRegisterSalesman: sessionStorage.getItem('isSupportRegisterSalesman'),
      columns: [
        {
          title: '条件指标最小值',
          key: 'minValue',
          key2: 'minValue',
          align: 'center',
          slot: 'input'
        },
        {
          title: '条件指标最大值',
          key: 'maxValue',
          key2: 'maxValue',
          align: 'center',
          slot: 'input'
        },
        {
          title: '增员类型',
          key: 'recommendType',
          align: 'center',
          slot: 'select'
        },
        {
          title: '奖励类型',
          key: 'rewardSelect',
          align: 'center',
          slot: 'rewardSelect'
        },
        {
          title: '奖励',
          key: 'value',
          key2: 'value',
          align: 'center',
          slot: 'input',
          width: '200'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center'
        }
      ]
    };
  },
  methods: {
    getTableData() {
      if (this.id && this.formData.type == 1) {
        this.$http({
          url: '/buz/merchantActivity/queryGradientConfig',
          type: 'GET',
          data: {
            id: this.id
          }
        }).then(res => {
          this.changeConditionalIndicator(this.formData.conditionalIndicator);
          this.tableData = res.data.map(item => {
            if ([3, 6].includes(this.formData.conditionalIndicator*1)) {
              if (this.formData.rewardType == 1) {
                item.value = item.rateReward;
              } else if (this.formData.rewardType == 2) {
                item.value = item.kindReward;
              } else {
                item.value = item.cashReward;
              }
            } else {
              if (item.kindReward) {
                item.rewardSelect = 'kindReward';
                item.value = item.kindReward;
              } else {
                item.rewardSelect = 'cashReward';
                item.value = item.cashReward;
              }
            }
            return {
              ...item,
              isEdit: false
            };
          });
          this.gradientConfigs = res.data;
        });
      }
    },
    changeType() {
      const formData = JSON.parse(JSON.stringify(this.formData));
      if (formData.type == 1) {
        formData.rewardType = '1';
      } else if(formData.type == 2) {
        formData.mode = '1';
        formData.rewardType = [];
      } else if(formData.type == 3) {
        formData.mode = '2';
        formData.rewardType = [];
      }
      this.$emit('typeChange', formData);
      this.$bus.$emit('resetList', formData);
    },
    changeMode(value) {
      if (value == 2 && this.formData.recommendTypes.includes('2')) {
        this.$set(this.formData, 'recommendTypes', [this.formData.recommendTypes + '']);
      }
      this.formData.joinType = '';
      this.formData.conditionalIndicator = '1';
      this.$bus.$emit('resetList', this.formData);
      this.$emit('typeChange', this.formData);
    },
    changeConditionalIndicator(value) {
      this.$emit('typeChange', this.formData);
      this.tableData = [];
      this.gradientConfigs = [];
      this.setColumns(value);
      if (!this.id) {
        this.formData.rewardType = '1';
      }
      if(value == 1 || value == 3) {
        this.formData.joinType = '1';
      }
    },
    // 增员人数条件指标下修改奖励类型
    changeRewardType(value) {
      if(!value.length || value.length==1) {
        let gradientConfigs = JSON.parse(JSON.stringify(this.gradientConfigs));
        gradientConfigs.forEach(item=>{
          delete item.cashReward;
          delete item.kindReward;
          delete item.rewardSelect;
          delete item.value;
        })
        this.$set(this, 'gradientConfigs', gradientConfigs);
      }
    },
    // 增员人数条件指标下修改奖励类型
    changeRewardSelect(value, item) {
      if(value=='kindReward') {
        // 选择实物删除现金字段
        delete item.cashReward
      }else{
        // 选择现金删除实物字段
        delete item.kindReward;
      }
    },
    setColumns(value) {
      this.columns = [];
      if (value == 6 || value == 3) {
        this.$set(this.formData, 'recommendTypes', ['2']);
        this.columns = [
          {
            title: '条件指标最小值',
            key: 'minValue',
            key2: 'minValue',
            align: 'center',
            slot: 'input'
          },
          {
            title: '条件指标最大值',
            key: 'maxValue',
            key2: 'maxValue',
            align: 'center',
            slot: 'input'
          },
          {
            title: '奖励',
            key: 'value',
            key2: 'value',
            align: 'center',
            slot: 'input',
            width: '200'
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center'
          }
        ];
      } else {
        this.columns = [
          {
            title: '条件指标最小值',
            key: 'minValue',
            key2: 'minValue',
            align: 'center',
            slot: 'input'
          },
          {
            title: '条件指标最大值',
            key: 'maxValue',
            key2: 'maxValue',
            align: 'center',
            slot: 'input'
          },
          {
            title: '增员类型',
            key: 'recommendType',
            align: 'center',
            slot: 'select'
          },
          {
            title: '奖励类型',
            key: 'rewardSelect',
            align: 'center',
            slot: 'rewardSelect'
          },
          {
            title: '奖励',
            key: 'value',
            key2: 'value',
            align: 'center',
            slot: 'input',
            width: '200'
          },
          {
            title: '操作',
            slot: 'action',
            align: 'center'
          }
        ];
      }
    },
    addTable() {
      this.tableData.push({
        isEdit: true
      });
      this.gradientConfigs.push({});
    },
    delTable(index) {
      this.tableData.splice(index, 1);
      this.gradientConfigs.splice(index, 1);
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate(valid => {
          if (valid) {
            try {
              if (this.formData.mode == 2 && !this.gradientConfigs.length) {
                this.$Message.error('请配置梯度活动奖励');
                return;
              }
              this.gradientConfigs.map((item, index) => {
                if ((!item.minValue && item.minValue != 0)  || (!item.value && item.value != 0)) {
                  this.$notice.error(`请完善第${index + 1}行表格内容`);
                  throw new Error();
                } else if (item.maxValue && Number(item.minValue) > Number(item.maxValue)) {
                  this.$notice.error(`第${index + 1}行中，最小值需小于最大值`);
                  throw new Error();
                }
              });
              if (this.formData.conditionalIndicator == 1 && this.formData.mode != 1) {
                this.formData.rewardType = this.formData.rewardType.join(',');
              } else if (this.formData.mode == 1 && this.formData.type == 1) {
                this.formData.rewardType = '1';
              }
              resolve({
                ...this.formData
              });
              if(this.formData.conditionalIndicator == 1 && this.formData.mode != 1) {
                this.formData.rewardType = this.formData.rewardType.split(',');
              }
            } catch (error) {
              reject();
              console.log(error);
            }
          } else {
            reject();
          }
        });
      });
    },
    setData(data) {
      const formData = {
        status: String(data.status),
        type: String(data.type),
        mode: String(data.mode),
        joinType: String(data.joinType ? data.joinType : ''),
        rewardType: [3, 6].includes(data.conditionalIndicator*1) ? String(data.rewardType ? data.rewardType : '') : data.rewardType.split(','),
        calFactor: data.calFactor ? String(data.calFactor) : '',
        rewardRate: data.rewardRate ? String(data.rewardRate) : '',
        conditionalIndicator1: data.conditionalIndicator1 ? String(data.conditionalIndicator1) : '',
        productType: String(data.productType ? data.productType : ''),
        recommendTypes: data.recommendTypes ? JSON.parse(data.recommendTypes) : [],
        endorsementIsJoin: String(data.endorsementIsJoin == '0 ' || data.endorsementIsJoin == 1 ? data.endorsementIsJoin : ''),
        conditionalIndicator: data.conditionalIndicator ? String(data.conditionalIndicator) : ''
      };
      if(data.joinPolicyTypeList) {
        formData.joinPolicyTypeList = data.joinPolicyTypeList.map(value => value.toString());
      } else {
        formData.joinPolicyTypeList = [];
      }
      this.formData = formData;
      this.$nextTick(() => {
        this.getTableData();
      });
    }
  },
  watch: {
    tableList: {
      handler() {
        if (this.compontntType != 'configModal') {
          this.tableList.map(item => {
            if (item.kindReward) {
              item.rewardSelect = 'kindReward';
              item.value = item.kindReward;
            } else {
              item.rewardSelect = 'cashReward';
              item.value = item.cashReward;
            }
          });
        }
        this.tableData = _.cloneDeep(this.tableList);
        this.gradientConfigs = _.cloneDeep(this.tableList);
      },
      immediate: true
    },
    activityType(newVal) {
      this.formData.type = newVal;
    }
  }
};
</script>
<style lang="scss" scoped>
.tip {
  display: flex;
  align-items: center;
  height: 40px;
  height: 40px;
  padding-left: 20px;
  background: #f7faff;
  border-radius: 4px;
  margin-bottom: 20px;
  .title {
    font-weight: bold;
  }
  p {
    color: #3f6ec9;
    font-size: 12px;
  }
}
.btn-item {
  margin-bottom: 30px;
  display: flex;
}
/deep/ .ivu-radio-group-item {
  margin-right: 20px !important;
}
/deep/ .ivu-checkbox-group-item {
  margin-right: 20px !important;
}
</style>
